// extracted by mini-css-extract-plugin
export default {"link":"Navbar_link__xx3Qm","linkActive":"Navbar_linkActive__fQyQq","linkChild":"Navbar_linkChild__84gAo"};